export default __webpack_public_path__ + "static/media/71505564000124.7bbe6b5b.png";